<template>
  <div
    v-if="crew.triads.length"
    :class="'dashboard__crew p-4 crew-' + crew.id + (!index ? ' on' : '')"
    :style="'--max-height:' + setMaxCrewHeight(index, crew) + 'px'"
  >
    <h3 class="mb-0">
      <button class="dashboard__crew__title" @click="toggle(crew.id, 'crew-', true)">
        {{ crew.title }}
        <FontAwesomeIcon icon="fa-light fa-chevron-down"></FontAwesomeIcon>
      </button>
    </h3>
    <div class="dashboard__crew__item">
      <div v-for="triad in crew.triads" :key="triad.id" class="dashboard__triad" @click="dashboard(triad.id)">
        <div class="dashboard__triad__apprentice d-flex align-items-center" v-if="triad.apprentice">
          <span class="badge -apprentice" v-if="apprenticeProfileLabel && apprenticeProfileLabel.titleAbbreviation">{{
            apprenticeProfileLabel.titleAbbreviation.toUpperCase()
          }}</span>
          <span v-if="triad.apprentice && triad.apprentice.fullName" class="d-flex align-items-center">
            <span
              :class="'name ' + (type === 'note' ? 'apprenticeBadge' : '')"
              v-tooltip="{
                title: triad.apprentice.fullName,
              }"
            >
              {{ triad.apprentice.fullName }}
            </span>
            <FontAwesomeIcon
              v-if="triad.activeContractRuptureDate || triad.contractRuptureDate"
              v-tooltip="{
                title:
                  $t('studea_manager.contract.contract_rupture_date') +
                  formatDate(
                    triad.activeContractRuptureDate ? triad.activeContractRuptureDate : triad.contractRuptureDate,
                  ),
              }"
              icon="fa-light fa-link-slash"
              class="text-danger"
            />
          </span>
          <span v-else>--</span>
        </div>
        <div
          v-if="triad.tutor"
          class="d-flex align-items-center"
          v-tooltip="{
            title: triad.tutor.fullName,
          }"
        >
          <span class="badge -tutor" v-if="tutorProfileLabel && tutorProfileLabel.titleAbbreviation">{{
            tutorProfileLabel.titleAbbreviation.toUpperCase()
          }}</span>
          <span v-if="triad.tutor && triad.tutor.fullName" class="name">
            {{ triad.tutor.fullName }}
          </span>
          <span v-else>--</span>
        </div>
        <div
          class="d-flex align-items-center"
          v-tooltip="{
            title: triad.apprenticeMaster ? triad.apprenticeMaster.fullName : '',
          }"
        >
          <span
            class="badge -apprenticeMaster"
            v-if="apprenticeMasterProfileLabel && apprenticeMasterProfileLabel.titleAbbreviation"
            >{{ apprenticeMasterProfileLabel.titleAbbreviation.toUpperCase() }}</span
          >
          <span v-if="triad.apprenticeMaster && triad.apprenticeMaster.fullName" class="name">
            {{ triad.apprenticeMaster.fullName }}
          </span>
          <span v-else>--</span>
        </div>
        <div class="d-flex align-items-center" v-if="studeaManagerProfileLabel && studeaManagerProfileLabel.title">
          <span class="badge -leaManager">CL</span>
          {{ studeaManagerProfileLabel.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { studeaManagerManager } from "@/services/studea-manager/studea-manager-manager";
import { mapState } from "pinia";
import { usePlatformStore } from "@/store/platform/platform";
import { dateFormatter } from "@/services/utilities/date-formatter";

export default {
  name: "AccordionCrewComponent",
  components: {},
  props: {
    crew: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(usePlatformStore, {
      apprenticeProfileLabel: (store) => store.apprenticeProfileLabel,
      tutorProfileLabel: (store) => store.tutorProfileLabel,
      apprenticeMasterProfileLabel: (store) => store.apprenticeMasterProfileLabel,
      studeaManagerProfileLabel: (store) => store.studeaManagerProfileLabel,
    }),
  },
  methods: {
    setMaxCrewHeight(index, crew) {
      return crew.triads.length * 135;
    },

    toggle(item, name, isMultipleElement) {
      studeaManagerManager.toggle(item, name, isMultipleElement);
    },

    formatDate(date) {
      return dateFormatter.format(date, "short");
    },

    dashboard(id) {
      this.$emit("goDashbord", id);
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  &__crew {
    border-bottom: 1px solid #e0e6ed;
    text-align: center;

    &__title {
      width: 100%;
      background-color: var(--primary-color);
      color: $white;
      border-radius: 6px;
      padding: 5px 20px;
      border: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      svg {
        transform: rotate(0deg);
        transition: all 300ms ease-in-out;
        margin-left: 10px;
      }
    }

    &__item {
      transition: all 300ms ease-in-out;
      overflow: hidden;
      height: 0;
    }

    &.on {
      .dashboard__crew__item {
        height: var(--max-height);
      }

      .dashboard__crew__title {
        svg {
          transform: rotate(-180deg);
        }
      }
    }
  }

  &__triad {
    padding: 15px 0;
    border-bottom: 1px dashed #e0e6ed;
    height: 135px;
    cursor: pointer;

    div {
      display: flex;
      justify-content: start;
      margin-top: 5px;
      margin-left: 20px;
    }

    .name {
      display: block;
      max-width: 120px;
      margin-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &.apprenticeBadge {
        background-color: $green;
        padding: 2px 10px;
        color: #fff;
        border-radius: 6px;
      }
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }

    &__apprentice {
      font-weight: 700;
    }
  }
}

.badge {
  width: 20px;
  height: 20px;
  font-size: 0.5rem;
  padding: 3px 4px;
  margin-right: 15px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: default;
  }

  &.-apprentice {
    background: $green;
  }

  &.-tutor {
    background: $purple;
  }

  &.-apprenticeMaster {
    background: $red;
  }

  &.-leaManager {
    background: $orange;
  }
}
</style>
